import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type AccountInfoData = {};

export class AccountInfo extends Resource<AccountInfoData> {
  constructor(axiosInstance: AxiosInstance) {
    super("accountInfo", axiosInstance);
  }

  public async get(): Promise<AccountInfo> {
    return this.request({ method: Method.GET });
  }
}
